"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionsComparison = exports.FunctionRowSchema = void 0;
const z = require("zod");
const component_function_denormalized_1 = require("../../DataScience/Types/component-function-denormalized");
const comparison_spec_1 = require("../comparison-spec");
exports.FunctionRowSchema = z.object({
    name: z.string(),
    functionClass: z.string(),
    busRole: z.string(),
    mustBeAssigned: z.boolean(),
    resourceConsumed: z.string(),
    functionSignals: component_function_denormalized_1.ComponentFunctionSignalDenormalizedSchema.array(),
});
function canonicalizeFunctionSignals(functionSignals) {
    const canonical = functionSignals
        .map((signal) => ({
        name: signal.name,
        busType: signal.busType ?? '',
        signalTypes: signal.signalTypes === null ? '' : [...signal.signalTypes].sort().join(','),
        optional: signal.optional,
    }))
        .sort((a, b) => a.name.localeCompare(b.name));
    return JSON.stringify(canonical);
}
class FunctionsComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.SetAlignment();
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return this.alignment.identityOf(row, (column, value, rowContext) => this.normalize(column, value, rowContext), Object.keys(row).sort());
    }
    normalize(column, value, row) {
        if (column === 'functionSignals' && Array.isArray(value)) {
            return canonicalizeFunctionSignals(value);
        }
        return super.normalize(column, value, row);
    }
}
exports.FunctionsComparison = FunctionsComparison;
//# sourceMappingURL=functions.comparison.js.map